var _templateObject, _templateObject2;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-67i5si-0"
})(["", ""], function (_ref) {
  var _ref$withMargin = _ref.withMargin,
    withMargin = _ref$withMargin === void 0 ? true : _ref$withMargin;
  return withMargin && maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["margin: 48px auto;"])));
});
export var Subscribe = styled.div.withConfig({
  displayName: "partials__Subscribe",
  componentId: "sc-67i5si-1"
})(["width:100%;padding:18px 24px;", " border-radius:", ";box-shadow:", ";", " ", ";", " h4{padding-bottom:0;", ";", " ", "}p{padding-top:6px;}input{width:100%;padding:7px 48px 6px 12px;border:1px solid ", ";border-radius:", ";box-shadow:0 1px 2px rgb(0 0 0 / 0.05);background-color:#fff;", ";color:", ";::placeholder{color:", ";}&:focus{border-color:", ";box-shadow:0 1px 2px rgb(23 113 251 / 0.2);}}small{display:block;opacity:0.5;margin-top:9px;", ";}", ";"], function (_ref2) {
  var theme = _ref2.theme,
    borderColor = _ref2.borderColor;
  return borderColor ? "border: 1px solid ".concat(theme.colors[borderColor], ";") : 'padding: 0;';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme,
    backgroundColor = _ref5.backgroundColor;
  return backgroundColor && "background-color: ".concat(theme.colors[backgroundColor], ";");
}, getFont(-1), function (_ref6) {
  var _ref6$withBorder = _ref6.withBorder,
    withBorder = _ref6$withBorder === void 0 ? true : _ref6$withBorder;
  return !withBorder && "border: none; border-radius: 0; box-shadow: none;";
}, function (_ref7) {
  var small = _ref7.small;
  return small && getFont(0);
}, function (_ref8) {
  var titleFontWeight = _ref8.titleFontWeight;
  return titleFontWeight && "font-weight: ".concat(titleFontWeight, ";");
}, function (_ref9) {
  var titleLineHeight = _ref9.titleLineHeight;
  return titleLineHeight && "line-height: ".concat(titleLineHeight, ";");
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.uiM;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadius;
}, getFont(0), function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.placeholderColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.accent1L;
}, getFont(-2, 'compact'), maxMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", " {\n        display: block;\n        text-align: center;\n\n        h4 {\n          margin-bottom: 12px;\n        }\n\n        button {\n          margin: 0;\n        }\n      }\n  "])), Flex));
export var ConfirmButton = styled.div.withConfig({
  displayName: "partials__ConfirmButton",
  componentId: "sc-67i5si-2"
})(["position:absolute;top:0;bottom:0;right:0;width:42px;border-radius:", ";cursor:pointer;background-color:", ";color:#fff;text-align:center;transition:all ease 0.24s;", " svg{position:absolute;top:9px;right:9px;transition:transform 0.15s ease;}", ""], function (_ref15) {
  var theme = _ref15.theme;
  return "0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0");
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.primary;
}, function (_ref17) {
  var isValid = _ref17.isValid;
  return !isValid && css(["background-color:", ";color:", ";cursor:not-allowed;"], function (_ref18) {
    var theme = _ref18.theme;
    return theme.colors.primaryLL;
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.colors.uiD;
  });
}, function (_ref20) {
  var isValid = _ref20.isValid;
  return isValid && css(["&:hover{svg{transform:translateX(2px);}}"]);
});
export var SubscribeButton = styled.div.withConfig({
  displayName: "partials__SubscribeButton",
  componentId: "sc-67i5si-3"
})(["position:relative;min-height:42px;", " button{position:relative;padding-right:42px;", " svg{position:absolute;top:9px;right:9px;transition:transform 0.15s ease;}&:hover{svg{transform:translateX(2px);}}}"], function (_ref21) {
  var withPadding = _ref21.withPadding;
  return withPadding && "margin-top: 18px;";
}, function (_ref22) {
  var theme = _ref22.theme,
    buttonColor = _ref22.buttonColor,
    buttonBorderColor = _ref22.buttonBorderColor,
    buttonBackgroundColor = _ref22.buttonBackgroundColor,
    buttonHover = _ref22.buttonHover;
  return "\n      color: ".concat(theme.colors[buttonColor], ";\n      background-color: ").concat(theme.colors[buttonBackgroundColor], ";\n      ").concat(buttonBorderColor && "border: 1px solid ".concat(theme.colors[buttonBorderColor], ";"), "\n\n      ").concat(!buttonHover ? '' : "\n              &:hover,\n              &:not(:disabled):hover {\n                color: ".concat(theme.colors[buttonBackgroundColor], ";\n                background-color: ").concat(theme.colors[buttonColor], ";\n              }"), "\n      ");
});
export var EmailInput = styled.div.withConfig({
  displayName: "partials__EmailInput",
  componentId: "sc-67i5si-4"
})(["position:relative;", ""], function (_ref23) {
  var withPadding = _ref23.withPadding;
  return withPadding && "margin-top: 18px;";
});